import UPDATE_FREE_TAG_SPEC_ITEM from './updateFreeTagSpecItem.graphql'
export default UPDATE_FREE_TAG_SPEC_ITEM
